import React from 'react';
import { Form, Input, Button, Card, Typography, Alert, Space, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useLogin } from '../hooks/useLogin';
import { StorageService } from '../../../shared/services/storage.service';

const { Title, Text } = Typography;

interface LoginFormValues {
  username: string;
  password: string;
  remember: boolean;
}

interface LoginFormProps {
  onSuccess?: () => void;
}

export function LoginForm({ onSuccess }: LoginFormProps) {
  const { login, isLoading, error } = useLogin();
  const [form] = Form.useForm();

  const handleSubmit = async (values: LoginFormValues) => {
    // Set remember me preference before login
    StorageService.setRememberMe(values.remember);
    const success = await login(values.username, values.password);
    if (success && onSuccess) {
      onSuccess();
    }
  };

  return (
    <Card style={{ width: 360, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center' }}>
          <Title level={4} style={{ margin: 0 }}>
            CBS Support
          </Title>
          <Text type="secondary" style={{ fontSize: 13 }}>Вход в систему</Text>
        </div>

        {error && (
          <Alert message={error} type="error" showIcon closable />
        )}

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
          size="middle"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Введите имя пользователя' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Имя пользователя"
              autoFocus
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Пароль"
            />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked" initialValue={StorageService.getRememberMe()}>
            <Checkbox>Запомнить меня</Checkbox>
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
            >
              Войти
            </Button>
          </Form.Item>
        </Form>

        <Text type="secondary" style={{ textAlign: 'center', display: 'block', fontSize: 11 }}>
          v{process.env.REACT_APP_VERSION || '0.1.0'}
        </Text>
      </Space>
    </Card>
  );
}
